<form
    id="pdfPrintSettingsForm"
    name="pdfPrintSettingsForm"
    novalidate
    autocomplete="off"
    #pdfPrintSettingsForm="ngForm">
    @if (gotPrerequisites()) {
        <div>
            <div class="well">
                <div class="row">
                    <div class="col-xs-6 general-settings">
                        <h5>General</h5>
                        <div class="row">
                            <div class="col-xs-12">
                                <label class="control-label">Paper size</label>
                                <div class="well well-sm">{{getPaperSize()}}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <label class="control-label">Plotting reference scale</label>
                                <div class="well well-sm">{{getReferenceScale()}}</div>
                            </div>
                        </div>
                        @if (showWatermark()) {
                            <div class="row">
                                <div class="col-xs-12">
                                    <label class="control-label">Watermark</label>
                                    <div
                                        class="input-group"
                                        [ngClass]="{'has-error': watermark | formFieldHasError}">
                                        <span class="input-group-addon corner">
                                            <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                                        </span>
                                        <textarea
                                            class="form-control"
                                            name="watermark"
                                            placeholder="Enter watermark"
                                            rows="2"
                                            cols="40"
                                            [maxlength]="maxWatermarkCharacters"
                                            [nlrPattern]="watermarkRegex"
                                            [(ngModel)]="model.watermarkText"
                                            #watermark="ngModel">
                                        </textarea>
                                    </div>
                                    @if (watermark.valid) {
                                        <p class="text-right">
                                            <span>{{getWatermarkCharactersRemaining() + ' characters remaining'}}</span>
                                        </p>
                                    }
                                    @if (watermark | formFieldHasError) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            <span>PDF watermark text is not valid.</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        <div class="row row-checkboxes">
                            <div class="col-xs-12">
                                <span class="nlr-checkbox">
                                    <input
                                        [name]="'printHiddenAnnotationsAndFeatures'"
                                        id="printHiddenAnnotationsAndFeatures"
                                        type="checkbox"
                                        tabindex="0"
                                        [(ngModel)]="model.printHiddenFeatures"
                                        [disabled]="printHiddenFeaturesDisabled()" />
                                    <label for="printHiddenAnnotationsAndFeatures">Print Hidden Annotation(s) and Feature(s)</label>
                                </span>
                            </div>
                            <div class="col-xs-12">
                                <span class="nlr-checkbox">
                                    <input
                                        [name]="'printEnlargementPolygons'"
                                        id="printEnlargementPolygons"
                                        type="checkbox"
                                        tabindex="0"
                                        [(ngModel)]="model.printEnlargementExtents" />
                                    <label for="printEnlargementPolygons">Print Enlargement Polygon(s)</label>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <h5>Print order</h5>
                        @if (!pageOrderDisabled()) {
                            <label class="control-label textInfo"> To reorder, drag and drop items and pages </label>
                        }
                        <div class="well well-sm">
                            <div class="row">
                                <div class="col-page-number">
                                    <span>1</span>
                                </div>
                                <div class="col-page-items">
                                    <div class="list-group">
                                        <div class="list-group-item">
                                            <span>Main Plan Graphic - Full page</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if (pageItemIdsList.length) {
                            <div
                                class="sortable-pages col-xs-12"
                                cdkDropListGroup
                                cdkDropList
                                [cdkDropListDisabled]="accessRestriction"
                                [cdkDropListData]="pageItemIdsList"
                                (cdkDropListDropped)="dropList($event)"
                                [ngClass]="{'disabled-cursor': pageReorderingDisabled()}">
                                @for (pageItemIds of pageItemIdsList; track pageItemIds; let i = $index) {
                                    <div
                                        cdkDrag
                                        cdkDragLockAxis="y"
                                        cdkDragPreviewContainer="parent"
                                        [cdkDragData]="pageItemIds"
                                        class="row">
                                        <div class="well well-sm">
                                            <div class="row">
                                                <div class="col-page-number">
                                                    <span>{{isEmptyLastPage(i) ? 'New page' : i + 2}}</span>
                                                </div>
                                                @if (getMaxPageItems(pageItemIds) === 1) {
                                                    <div class="col-page-items">
                                                        <div class="list-group">
                                                            <div class="list-group-item">
                                                                <span>{{getPageItemDisplayName(pageItemIds[0])}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                @if (getMaxPageItems(pageItemIds) === 4) {
                                                    <div class="col-page-items">
                                                        <div
                                                            class="sortable-page-items list-group"
                                                            cdkDropList
                                                            [cdkDropListDisabled]="accessRestriction"
                                                            [cdkDropListData]="pageItemIds"
                                                            (cdkDropListDropped)="dropItem($event)">
                                                            @for (pageItemId of pageItemIds; track pageItemId) {
                                                                <div
                                                                    class="list-group-item page-item"
                                                                    cdkDrag
                                                                    cdkDragLockAxis="y"
                                                                    [cdkDragData]="pageItemId">
                                                                    <span>{{getPageItemDisplayName(pageItemId)}}</span>
                                                                    <i class="nlrp-icon nlrp-icon-move pull-right"></i>
                                                                </div>
                                                            }
                                                            @if (isEmptyLastPage(i)) {
                                                                <div
                                                                    class="list-group-item page-item"
                                                                    cdkDrag
                                                                    cdkDragLockAxis="y">
                                                                    <em>Drag item here to create a new page</em>
                                                                </div>
                                                            }
                                                        </div>
                                                        @if (!isEmptyLastPage(i)) {
                                                            <div class="text-right">
                                                                <em>{{(getMaxPageItems(pageItemIds) - pageItemIds.length) + ' remaining'}}</em>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                @if (!isEmptyLastPage(i)) {
                                                    <div class="col-page-actions text-right">
                                                        <i class="nlrp-icon nlrp-icon-move"></i>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        <div class="row">
                            <div class="col-xs-12">
                                @if (!accessRestriction || (['EDIT_PLAN', 'VIEW_PLAN'] | hasPermissions)) {
                                    <button
                                        type="button"
                                        class="btn btn-default nlr-btn-sm"
                                        title="Reset"
                                        (click)="resetPageOrder()"
                                        [disabled]="resetPageOrderDisabled() || (['EDIT_PLAN', 'VIEW_PLAN'] | disabledByPermissions)">
                                        Reset
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row debugger">
                    @if (showModel) {
                        <div class="col-xs-4">
                            <h5>Model</h5>
                            <pre>{{toJson(model)}}</pre>
                        </div>
                    }
                    @if (showModel) {
                        <div class="col-xs-4">
                            <h5>Selected paper size</h5>
                            <pre>{{toJson(getPaperSizeLookup())}}</pre>
                        </div>
                    }
                    @if (showModel) {
                        <div class="col-xs-4">
                            <h5>Selected reference scale</h5>
                            <pre>{{toJson(getReferenceScaleLookup())}}</pre>
                        </div>
                    }
                    @if (showPageItemIdsList) {
                        <div class="col-xs-4">
                            <h5>pageItemIdsList</h5>
                            <pre>{{toJson(pageItemIdsList)}}</pre>
                        </div>
                    }
                    @if (showPageItemList) {
                        <div class="col-xs-4">
                            <h5>pageItemList</h5>
                            <pre>{{toJson(pageItemListAttributes())}}</pre>
                        </div>
                    }
                    @if (showPristinePageItemList) {
                        <div class="col-xs-4">
                            <h5>pristinePageItemList</h5>
                            <pre>{{toJson(pristinePageItemListAttributes())}}</pre>
                        </div>
                    }
                    @if (showPlan) {
                        <div class="col-xs-12">
                            <h5>planLodgement</h5>
                            <pre>{{toJson(getPlanModel())}}</pre>
                        </div>
                    }
                </div>
            </div>
            @if (!hasPrintAreaGeometry()) {
                <div class="row">
                    <div class="col-xs-12">
                        <div
                            class="alert alert-danger"
                            role="alert">
                            <i class="nlrp-icon nlrp-icon-warning"></i>Warning! A print area has not been defined for the main plan!
                        </div>
                    </div>
                </div>
            }
            <div class="row">
                <div class="col-xs-8">
                    @if (accessRestriction) {
                        <button
                            id="printPdf"
                            type="button"
                            class="btn btn-default nlr-btn-sm"
                            title="Print"
                            (click)="print()"
                            [disabled]="pdfPrintSettingsForm.invalid">
                            Print
                        </button>
                    }
                    @if (!accessRestriction && (['EDIT_PLAN'] | hasPermissions)) {
                        <button
                            id="savePdfSettingsAndPrint"
                            type="button"
                            class="btn btn-default nlr-btn-sm"
                            title="Print"
                            (click)="saveAndPrint()"
                            [disabled]="pdfPrintSettingsForm.invalid || (['EDIT_PLAN'] | disabledByPermissions)">
                            Print
                        </button>
                    }
                    @if (!accessRestriction && (['EDIT_PLAN'] | hasPermissions)) {
                        <button
                            id="savePdfSettings"
                            type="button"
                            class="btn btn-default nlr-btn-sm"
                            title="Save"
                            (click)="save()"
                            [disabled]="saveDisabled() || pdfPrintSettingsForm.invalid || (['EDIT_PLAN'] | disabledByPermissions)">
                            Save
                        </button>
                    }
                    <button
                        id="closePdfSettings"
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        title="Close"
                        (click)="cancel()">
                        Close
                    </button>
                </div>
                <div class="col-xs-4 debugger">
                    <div
                        class="btn-group pull-right"
                        role="group">
                        <button
                            type="button"
                            class="btn btn-xs"
                            [ngClass]="{'btn-default': !showModel, 'btn-success': showModel}"
                            (click)="showModel = !showModel">
                            Model
                        </button>
                        <button
                            type="button"
                            class="btn btn-xs"
                            [ngClass]="{'btn-default': !showPageItemIdsList, 'btn-success': showPageItemIdsList}"
                            (click)="showPageItemIdsList = !showPageItemIdsList">
                            pageItemIdsList
                        </button>
                        <button
                            type="button"
                            class="btn btn-xs"
                            [ngClass]="{'btn-default': !showPageItemList, 'btn-success': showPageItemList}"
                            (click)="showPageItemList = !showPageItemList">
                            pageItemList
                        </button>
                        <button
                            type="button"
                            class="btn btn-xs"
                            [ngClass]="{'btn-default': !showPristinePageItemList, 'btn-success': showPristinePageItemList}"
                            (click)="showPristinePageItemList = !showPristinePageItemList">
                            pristinePageItemList
                        </button>
                        <button
                            type="button"
                            class="btn btn-xs"
                            [ngClass]="{'btn-default': !showPlan, 'btn-success': showPlan}"
                            (click)="showPlan = !showPlan">
                            planLodgement
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
</form>
